import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "../i18n/LangContext";
import { ORG } from "../seo/site";
import "../styles/Cta.css";

// The whole site offers exactly two next steps: book a call, or send a message.
// Both live here so the label and the booking URL have a single home.
// ORG.bookingUrl is the one source for the calendar link.

export const BookButton = ({ short = false, className = "" }) => {
  const { t } = useTranslation();
  return (
    <a
      href={ORG.bookingUrl}
      className={`cta-primary ${className}`.trim()}
      target="_blank"
      rel="noopener noreferrer"
    >
      {t(short ? "cta.bookShort" : "cta.book")}
    </a>
  );
};

export const MessageButton = ({ className = "" }) => {
  const { t } = useTranslation();
  return (
    <Link to="/contact" className={`cta-secondary ${className}`.trim()}>
      {t("cta.message")}
    </Link>
  );
};

const CtaPair = ({ tone = "light", short = false, secondary = true, align = "start", className = "" }) => (
  <div className={`cta-pair cta-pair--${tone} cta-pair--${align} ${className}`.trim()}>
    <BookButton short={short} />
    {secondary && <MessageButton />}
  </div>
);

export default CtaPair;
